import React from 'react'
import { TextField } from 'hhsoig-design-system-core'

export const WeightField = ({ field, form, measurementField }) => {
  const { errors, touched, values } = form
  const postText =
    values[measurementField] === 'metric' ? 'kilograms' : 'pounds'
  const errorMessage =
    touched && touched[field.name] && errors && errors[field.name]
  return (
    <div className="ds-l-form-row ds-u-align-items--end">
      <div className="ds-l-col--auto">
        <TextField
          errorMessage={errorMessage}
          label="Weight (approximate)"
          type="number"
          size="medium"
          {...field}
        />
      </div>
      <div className="ds-l-col--auto ds-u-margin-bottom--2">
        <span>{postText}</span>
      </div>
    </div>
  )
}
